// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"36e8fa1b","58":"07f44eac","78":"2b8c3bef","253":"2efca5de","429":"7e207ed4","558":"f7a72a66","597":"5fa31ed4","656":"7826b42c","710":"22ff7270","797":"c6b8620b","879":"a4a8705a"}[chunkId] + ".chunk.js";
};